import { RepeatType } from 'src/enums'

/**
 * Whether a Maintenance's `frequency` value clears the "greater than zero" rule,
 * once the earlier required/integer-only checks have already passed.
 *
 * Closes HSE-19756: a stored Frequency of 0 (or negative) let a Maintenance be
 * saved with a value that could never advance the weekly-schedule generation
 * loop, hanging CreateScheduleMaintenanceJob. Skipped when the repeat type is
 * Never or the field is empty — those cases are covered by the separate
 * "required" refine.
 */
export const isMaintenanceFrequencyValid = (val: string | undefined, repeatType: RepeatType): boolean => {
  if (repeatType === RepeatType.Never || !val) return true
  return Number(val) > 0
}
